








































import { Component, Vue } from 'vue-property-decorator';
import ShowFilePreviewModal from '@/components/storage/modals/ShowFilePreviewModal.vue'

@Component({
  components: {
    ShowFilePreviewModal,
  }
})
export default class OftenUseFileList extends Vue {
  private files: Array<{ name: string; type: string; src: string; }> = [
    {
      name: 'サンプル0(PDF)',
      type: 'pdf',
      src: 'https://www.kansaigaidai.ac.jp/asp/img/pdf/82/7a79c35f7ce0704dec63be82440c8182.pdf'
    },
    {
      name: 'サンプル1(image)',
      type: 'image',
      src: 'https://imgsv.nikon-image.com/products/slr/lineup/d5300/img/sample/pic_03_l.jpg'
    },
    // 以下OneDrive
    {
      name: 'サンプル2(Word)',
      type: 'Word',
      src: 'https://onedrive.live.com/embed?cid=91CA6EBA5A0DEBD1&resid=91CA6EBA5A0DEBD1%21125&authkey=AKLNwMvvwsZaan8&em=2'
    },
    {
      name: 'サンプル3(Excel)',
      type: 'Excel',
      src: 'https://onedrive.live.com/embed?cid=91CA6EBA5A0DEBD1&resid=91CA6EBA5A0DEBD1%21123&authkey=ANtitK2RZ1W-wlQ&em=2'
    },
    {
      name: 'サンプル4(PowerPoint)',
      type: 'PowerPoint',
      src: 'https://onedrive.live.com/embed?cid=91CA6EBA5A0DEBD1&resid=91CA6EBA5A0DEBD1%21120&authkey=AAx2YgK-aZbdeuM&em=2'
    },
    // Googleのリンクがすべて切れているので一時的に同じものを貼り付け(以下Googleドライブ)
    {
      name: 'サンプル5(pdf)',
      type: 'pdf',
      src: 'https://www.kansaigaidai.ac.jp/asp/img/pdf/82/7a79c35f7ce0704dec63be82440c8182.pdf'
    },
    {
      name: 'サンプル6(word)',
      type: 'Word',
      src: 'https://onedrive.live.com/embed?cid=91CA6EBA5A0DEBD1&resid=91CA6EBA5A0DEBD1%21125&authkey=AKLNwMvvwsZaan8&em=2'
    },
    {
      name: 'サンプル7(Excel)',
      type: 'Excel',
      src: 'https://onedrive.live.com/embed?cid=91CA6EBA5A0DEBD1&resid=91CA6EBA5A0DEBD1%21123&authkey=ANtitK2RZ1W-wlQ&em=2'
    },
    {
      name: 'サンプル8(PowerPoint)',
      type: 'PowerPoint',
      src: 'https://onedrive.live.com/embed?cid=91CA6EBA5A0DEBD1&resid=91CA6EBA5A0DEBD1%21120&authkey=AAx2YgK-aZbdeuM&em=2'
    },
    {
      name: 'サンプル9(PowerPoint)',
      type: 'PowerPoint',
      src: 'https://onedrive.live.com/embed?cid=91CA6EBA5A0DEBD1&resid=91CA6EBA5A0DEBD1%21120&authkey=AAx2YgK-aZbdeuM&em=2'
    },
    {
      name: 'サンプル10(PowerPoint)',
      type: 'PowerPoint',
      src: 'https://onedrive.live.com/embed?cid=91CA6EBA5A0DEBD1&resid=91CA6EBA5A0DEBD1%21120&authkey=AAx2YgK-aZbdeuM&em=2'
    },
    {
      name: 'サンプル11(PowerPoint)',
      type: 'PowerPoint',
      src: 'https://onedrive.live.com/embed?cid=91CA6EBA5A0DEBD1&resid=91CA6EBA5A0DEBD1%21120&authkey=AAx2YgK-aZbdeuM&em=2'
    },
  ];
  private file: object = {};
  private isShowFilePreviewModal: boolean = false;

  private switchShowFilePreviewModal(file: object): void {
    this.isShowFilePreviewModal = !this.isShowFilePreviewModal;
    this.file = file;
  }
}
